/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Sending/view.blocks to change it.
import LoadingBar from 'DesignSystem/LoadingBar/index'
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'
import { DialogOverlay as ViewsModalOverlay, DialogContent as ViewsModalOverlayContent } from '@reach/dialog'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Sending({
  children,
  viewPath = "/App/Account/Sending"
  
}) {
  return (<React.Fragment
>
<ViewsModalOverlay
  data-testid="Sending.Horizontal"
  data-view-path={viewPath}
 isOpen={true}
 className={`views-block ${styles.Horizontal}`}
>
<LoadingBar
  viewPath={`${viewPath}/LoadingBar`}
 borderBottomLeftRadius={4}
 borderBottomRightRadius={4}
 borderTopLeftRadius={4}
 borderTopRightRadius={4}
 height={8}
 width={300}
/>
</ViewsModalOverlay>
{children}
</React.Fragment>)
}